import requestApi from "@/utils/requestApi";

export default {
  name: "shopSetting",
  data() {
    return {
      checkboxSel: {
        isReceiptConfirmationByGoods: false,
        isSetWxFeeByGoods: false,
        isFastPaymentByGoods: false,
        isAlipayByGoods: false,
        isCategoryOptionsByGoods: false,
      },
      // 店铺基础设置
      shopDtlEntity: {},
      shop: {},
      isEnabledContract: 0,
      // 支付方式 在线支付 线下结算 暂不支付
      paymentMethod: [],
      // 配送方式 配送  自提
      shippingType: [],
      // 自提时间 类型
      selfPickupTimeType: "0",
      // 是否允许设置 自提时间 类型
      enableSelfPickUpTimeType: "",
      // 基础设置权限
      shopDtlRuleEntities: [],
      // 档案自动同步
      qlwSycCustomer: 0,
      // 银行卡支付
      isFastPayment: 0,
      // 支付宝支付
      isalipay: 0,
      // 收货确认
      isReceiptConfirmation: 0,
      // 是否开通易宝
      isAccStauts: 0,
      // 开通易宝路径
      openPayEnd: "",
      isZzinvoice: "",
      shopDtlRule: {},
      // 新版  走配置
      shopDtlRuleNew: [],
      options: [],
      optionsHasDisabled: [],
      // tagsList: [], // 选取的标签
      // tagsSumbit: [], // 选取的标签
      categoryOptionsList: [], //合同设置
      selectedOptions: [], // 选中的标签
      props: {
        value: "id", // TagID
        label: "classificationName",
        children: "children",
        multiple: true,
        // checkStrictly: true,
      },
      loading: true,
      //客服
      helpdeskBoId: "",
      helpdeskList: [],
      smsBoId: "",
    };
  },
  created() {
    //客服
    requestApi.post(`${process.env.VUE_APP_APITAAS}sctrading/shop/shophelpdesk/selList`, {}).then((res) => {
      this.helpdeskList = res.data;
    });
    this.query();
  },
  methods: {
    changeShippingType() {
      console.log("this.shippingType: ", this.shippingType);
      if (!this.shippingType || this.shippingType.length <= 0) {
        this.enableSelfPickUpTimeType = "";
        return;
      }

      // 是否启用店铺确认提货时间
      let isShopConfirmSelfPickUpTime = 0;
      let shopFuncSetting = this.shopDtlEntity.shopFuncSetting ? this.shopDtlEntity.shopFuncSetting : [];
      shopFuncSetting.forEach((item) => {
        if (item.key === "is_shop_confirm_self_pickup_time") {
          isShopConfirmSelfPickUpTime = parseFloat(item.value);
        }
      });

      let enableSelfPickUpTimeType = "";
      this.shippingType.forEach((item) => {
        if (item == "1" && isShopConfirmSelfPickUpTime) {
          enableSelfPickUpTimeType = "1";
        }
      });
      this.enableSelfPickUpTimeType = enableSelfPickUpTimeType;
    },
    query() {
      this.$store.dispatch("shop/shop/queryShopDtlByBoId").then((data) => {
        if (data.data) {
          this.shopDtlRuleNew = [];
          this.shopDtlEntity = data.data.shopDtlEntity;
          this.isEnabledContract = data.data.isEnabledContract;
          this.paymentMethod = data.data.paymentMethod;
          this.shippingType = data.data.shippingType;
          this.shopDtlRuleEntities = data.data.shopDtlRuleEntities;
          this.qlwSycCustomer = data.data.qlwSycCustomer;
          this.isAccStauts = data.data.isAccStauts;
          this.shop = data.data.shop;
          this.isFastPayment = data.data.isfastpayment ? Number(data.data.isfastpayment) : 0;
          this.isalipay = data.data.isalipay ? Number(data.data.isalipay) : 0;
          this.isReceiptConfirmation = data.data.isreceiptconfirmation ? Number(data.data.isreceiptconfirmation) : 0;
          this.isZzinvoice = Number(data.data.iszzinvoice);
          this.shopDtlEntity.isSupportInvoice = this.shopDtlEntity.isSupportInvoice ? Number(this.shopDtlEntity.isSupportInvoice) : 0;
          this.shopDtlRuleEntities.forEach((item) => {
            if (
              item.busType == "enabledContract" ||
              item.busType == "materialStatement" ||
              item.busType == "supportInvoice" ||
              item.busType == "othersGoodsReceipt" ||
              item.busType == "setWxFee" ||
              item.busType == "fastPayment" ||
              item.busType == "receiptConfirmation" ||
              item.busType == "zzInvoice" ||
              item.busType == "alipay"
            ) {
              this.$set(this.shopDtlRule, item.busType, item.status);
            } else if (item.status === 1) {
              item.value = Number(item.value);
              this.shopDtlRuleNew.push(item);
            }
          });
          this.categoryOptionsList = data.data.categoryOptionsList;
          // this.tagsSumbit = data.data.categoryOptionsList[0].category;
          // this.tagsList = this.tagsSumbit.map((item) => item.label.split("/"));
          this.openPayEnd = data.data.openPayEnd;
          this.handleCheckboxSel();
          this.loading = false;
          this.helpdeskBoId = data.data.shopHelpdesk ? data.data.shopHelpdesk.boId : "";
          this.smsBoId = this.shopDtlEntity.smsBoId ? this.shopDtlEntity.smsBoId : "";
          this.selfPickupTimeType = this.shopDtlEntity.selfPickupTimeType ? this.shopDtlEntity.selfPickupTimeType.toString() : "0";
          this.changeShippingType();
        }
      });
      this.$store.dispatch("shop/shop/getCategoryFirstList").then((data) => {
        this.options = JSON.parse(JSON.stringify(data));
        this.optionsHasDisabled = JSON.parse(JSON.stringify(data));
      });
    },
    // eslint-disable-next-line no-unused-vars
    changeContractCategory(index) {
      const nodesObj = this.$refs[`enabledContract${index}`][0].getCheckedNodes();

      const category = nodesObj.map((item) => ({ id: item.value, rank: item.level }));
      this.$set(this.categoryOptionsList[index], "category", category);

      const ids = nodesObj.map((item) => item.value);
      this.$set(this.categoryOptionsList[index], "categorySelected", ids);

      console.log("this.categoryOptionsList", this.categoryOptionsList);
    },
    focusContractCategory(data, visible) {
      if (!visible) {
        return;
      }

      function loop(data, cb) {
        data.forEach((item) => {
          if (item.children && item.children.length) {
            cb && cb(item);
            loop(item.children, cb);
          } else {
            cb && cb(item);
          }
        });
      }

      const optionsHasDisabled = JSON.parse(JSON.stringify(this.options));
      const { categoryOptionsList } = this;

      let categoryOptionsSelected = [];
      categoryOptionsList.forEach((item) => {
        if (item.templateType != "CG-NXKH" && item.templateType != data.templateType) {
          categoryOptionsSelected.push(...(item.categorySelected || []));
        }
      });
      categoryOptionsSelected = [...new Set(categoryOptionsSelected)];

      console.log("categoryOptionsSelected", categoryOptionsSelected);
      loop(optionsHasDisabled, (item) => {
        if (categoryOptionsSelected.includes(item.id)) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
      });
      loop(optionsHasDisabled, (item) => {
        if (item.children && item.children.length && item.children.some((item2) => !item2.disabled)) {
          item.disabled = false;
        }
      });
      loop(optionsHasDisabled, (item) => {
        if (item.children && item.children.length && item.children.some((item2) => !item2.disabled)) {
          item.disabled = false;
        }
      });

      this.optionsHasDisabled = optionsHasDisabled;

      console.log("optionsHasDisabled", optionsHasDisabled);
    },
    handleCheckboxSel() {
      // 默认加载处理是否应用全部商品
      this.checkboxSel.isAlipayByGoods = this.isalipay === 0;
      this.checkboxSel.isReceiptConfirmationByGoods = this.isReceiptConfirmation === 0;
      this.checkboxSel.isCategoryOptionsByGoods = this.shop.isEnabledContract === 0;
      this.checkboxSel.isFastPaymentByGoods = this.isFastPayment === 0;
      this.checkboxSel.isSetWxFeeByGoods = this.shopDtlEntity.isSetWxFee === 0;
    },
    save() {
      if (this.shippingType.length === 0) {
        this.$message.info("请选择配送方式");
        return;
      }
      // eslint-disable-next-line no-param-reassign
      const shippingTypeTotal = this.shippingType.reduce((totle, item) => (totle += Math.pow(2, parseInt(item))), 0);
      if (this.paymentMethod.length === 0) {
        this.$message.info("请选择支付方式");
        return;
      }
      if (!/^([0-9]*)$/.test(this.shopDtlEntity.firstPaymentRatioMin)) {
        this.$message.info("首次支付最小比例只能是正数");
        return;
      }
      if (this.shopDtlEntity.firstPaymentRatioMin < 0 || this.shopDtlEntity.firstPaymentRatioMin > 100) {
        this.$message.info("首次支付最小比例 0-100范围");
        return;
      }
      // eslint-disable-next-line no-param-reassign
      const paymentMethodTotal = this.paymentMethod.reduce((totle, item) => (totle += Math.pow(2, parseInt(item))), 0);
      // this.categoryOptionsList.forEach((item) => {
      //   if (item.checked) {
      //     item.category = this.tagsSumbit;
      //   }
      // });
      const data = {
        shopId: this.shop.shopIdStr,
        shippingType: shippingTypeTotal,
        paymentMethod: paymentMethodTotal,
        isReceiptConfirmation: this.isReceiptConfirmation,
        isSetWxFee: this.shopDtlEntity.isSetWxFee,
        isfastpayment: this.isFastPayment,
        isalipay: this.isalipay,
        categoryOptionsList: JSON.stringify(this.categoryOptionsList),
        isEnabledContract: this.shop.isEnabledContract,
        qlwSycCustomer: this.qlwSycCustomer,
        firstPaymentRatioMin: this.shopDtlEntity.firstPaymentRatioMin,
        isSupportInvoice: this.shopDtlEntity.isSupportInvoice,
        isSignMaterialStatement: this.shopDtlEntity.isSignMaterialStatement,
        isOthersGoodsReceipt: this.shopDtlEntity.isOthersGoodsReceipt,
        isCategoryOptions: this.checkboxSel.isCategoryOptionsByGoods ? 1 : 0,
        isSetWxFeeByGoods: this.checkboxSel.isSetWxFeeByGoods ? 1 : 0,
        isFastPaymentByGoods: this.checkboxSel.isFastPaymentByGoods ? 1 : 0,
        isReceiptConfirmationByGoods: this.checkboxSel.isReceiptConfirmationByGoods ? 1 : 0,
        isAlipayByGoods: this.checkboxSel.isAlipayByGoods ? 1 : 0,
        isZzinvoice: this.isZzinvoice,
        dtlRuleStr: this.shopDtlRuleNew ? JSON.stringify(this.shopDtlRuleNew) : "",
        helpdeskBoId: this.helpdeskBoId,
        smsBoId: this.smsBoId,
        selfPickupTimeType: this.selfPickupTimeType,
      };
      this.$store.dispatch("shop/shop/saveShopDtlByShopId", data).then((data) => {
        this.$message.info(data.msg);
        this.query();
      });
    },
    windowOpenPay() {
      if (self != top) {
        window.parent.location.href = this.openPayEnd;
      } else {
        window.location.href = this.openPayEnd;
      }
    },
  },
};
